import { createStore } from 'redux';
import rootReducer from 'stores/reducers';

/**
 * Creates redux store from our rootReducers
 */
const store = createStore(rootReducer);

export default store;
